import React from "react";
import BackgroundBuildingImage from "../../../shared/components/app/BackgroundBuildingImage";
import Background from "../../../shared/components/ui/Background";
import { Box } from "../../../shared/components/ui/chakra";

const BusinessEntityShowPreviewLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Box position="relative">
      <Background>
        <Box
          bgColor="textLink"
          textAlign="center"
          px={8}
          py={4}
          position="sticky"
          top={0}
          zIndex={100}
          fontSize="lg"
          fontWeight="bold"
          color="white"
        >
          プレビュー表示中
        </Box>
        {children}
      </Background>
      <BackgroundBuildingImage
        // positionをabsoluteにすると、width、transformも指定しないと横に空白が生まれる
        position="absolute"
        width="full"
        transform=""
      />
    </Box>
  );
};

export default BusinessEntityShowPreviewLayout;
